import { useEffect, useState } from "react";
import { Medal } from "lucide-react";
import { api, imgSrc } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const MEDAL = ["bg-gradient-to-br from-yellow-200 to-amber-500 text-amber-950", "bg-gradient-to-br from-slate-100 to-slate-400 text-slate-800", "bg-gradient-to-br from-orange-200 to-orange-500 text-orange-950"];

function Row({ r, me }) {
  const ranks = [[r.gold, "🥇"], [r.silver, "🥈"], [r.bronze, "🥉"]].filter(([n]) => n).map(([n, m]) => `${n}× ${m}`).join(" · ");
  return (
    <li className={`flex items-center gap-3 rounded-2xl px-3 py-2.5 ${me ? "bg-amber-100 ring-1 ring-amber-300" : "bg-white"}`} data-testid={`quest-hero-record-${r.place}`}>
      <span className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-sm font-black ${MEDAL[r.place - 1] || "bg-amber-50 text-amber-700"}`}>{r.place}</span>
      {r.picture ? <img src={imgSrc(r.picture)} alt="" className="w-10 h-10 rounded-full object-cover border-2 border-amber-300" />
        : <div className="w-10 h-10 rounded-full bg-amber-200 flex items-center justify-center font-black text-amber-800">{r.name?.[0]?.toUpperCase()}</div>}
      <div className="min-w-0 flex-1">
        <p className="font-bold text-slate-900 truncate">{r.name}{me && " (du)"}</p>
        <p className="text-[11px] text-slate-500">{ranks}</p>
      </div>
      <span className="font-display font-black text-amber-600 tabular-nums flex items-center gap-1">{r.count}× <Medal className="w-4 h-4" /></span>
    </li>
  );
}

export function QuestHeroRecords() {
  const { user } = useAuth();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/public/quest-heroes").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list) return null;
  return (
    <section className="mt-10 relative overflow-hidden rounded-[2rem] bg-gradient-to-b from-amber-100 via-yellow-50 to-white border-2 border-amber-300 p-5 sm:p-7 shadow-xl shadow-amber-100" data-testid="quest-hero-records">
      <div className="gold-banner absolute inset-x-0 top-0 h-1.5" aria-hidden />
      <p className="text-[11px] font-extrabold uppercase tracking-[0.3em] text-amber-600 flex items-center gap-1.5"><Medal className="w-3.5 h-3.5" /> Ewige Bestenliste</p>
      <h2 className="mt-1 font-display text-2xl sm:text-3xl font-black text-slate-900">Aufgaben-Helden</h2>
      <p className="mt-1 text-sm text-slate-500">Wer am häufigsten zu den 3 fleißigsten Helfern einer geschafften Community-Aufgabe gehörte.</p>
      {list.length === 0 ? <p className="mt-5 text-sm text-slate-500" data-testid="quest-hero-records-empty">Noch keine Aufgaben-Helden – hilf bei der nächsten Community-Aufgabe mit und werde die/der Erste!</p> : (
        <ol className="mt-5 space-y-2" data-testid="quest-hero-records-list">{list.map((r) => <Row key={r.user_id} r={r} me={r.user_id === user?.user_id} />)}</ol>
      )}
    </section>
  );
}
